import { ITimeFrame, TimeDataType } from 'apis/types';
import { isLunchTime } from 'utils/lunchTime';
import {
  CalendarWeekdayBit,
  getCalendarWeekdayBit,
  isHolidayFromServer,
  parseBusinessDate,
  parseBusinessTimeToMinutes,
} from 'utils/serverTime';

type TimingDayBit = 1 | CalendarWeekdayBit;

export interface MenuTimingContext {
  businessDate: string;
  businessMinute: number;
  dayOfMonth: number;
  timingDayBit: TimingDayBit;
  isLunch: boolean;
}

export const createMenuTimingContext = (
  serverTime: TimeDataType,
  timeFrames: ITimeFrame[],
  lunchFrameIds: string[]
): MenuTimingContext | null => {
  const dateParts = parseBusinessDate(serverTime.business_date);
  const businessMinute = parseBusinessTimeToMinutes(serverTime.tm_hh_mm);

  if (dateParts === null || businessMinute === null) return null;

  const isHoliday = isHolidayFromServer(serverTime.is_holiday);
  const calendarWeekdayBit = getCalendarWeekdayBit(dateParts);

  return {
    businessDate: serverTime.business_date,
    businessMinute,
    dayOfMonth: dateParts.day,
    timingDayBit: isHoliday ? 1 : calendarWeekdayBit,
    isLunch: isLunchTime(businessMinute, timeFrames, lunchFrameIds),
  };
};
